import React, { FC } from 'react';
import Button from '../../../../../../components/Button';

import imgURL from '../../../../../../lib/imgURL';
import { Props } from './typing';
import './style.scss';

const ProfileFooter: FC<Props> = (props) => {
  const { currentStep, nextPage, saveAction, enableSave, enableSaveAndNext, submitAction, blockNext, submitLabel } = props;

  return (
    <div className='profile-footer'>
      <div className='profile-footer-action'>
        <Button
          btnStyleClass='secondary-button save-action'
          label='Save'
          onClick={() => {
            saveAction(currentStep, {
              saved: true,
              completed: false
            });
          }}
          enable={enableSave}
        />

        <Button
          btnStyleClass='primary-button save-continue-action'
          label={submitLabel || 'Save and Next'}
          btnIcon={<img className='back-icon' src={imgURL['left-arrow']} />}
          btnIconPosition='right'
          onClick={() => {
            if (submitAction) {
              submitAction(); 
            } else {
              saveAction(currentStep, {
                saved: true,
                completed: true
              });
            }
            if (blockNext) {
              nextPage();
            }
          }}
          enable={enableSaveAndNext}
        />
      </div>
    </div>
  );
};

export default ProfileFooter;
